export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
